import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export enum WarehouseReturnType {
    REDELIVERY = 'REDELIVERY',
    REFUSAL = 'REFUSAL',
    COLLECTION = 'COLLECTION',
    OTHER = 'OTHER',
    NONE = 'NONE'
}

export enum WarehouseLoadingIssue {
    NONE = 'NONE',
    PACKAGING_DAMAGED = 'PACKAGING_IS_DAMAGED',
    EQUIPMENT_DAMAGED = 'EQUIPMENT_IS_DAMAGED',
    SHORT = 'SHORT',
    CAPTURE_OVER = 'CAPTURE_OVER'
}

export enum ScanType {
    BARCODE_SCAN = 'BARCODE_SCAN',
    ACCEPT_WITHOUT_BARCODE = 'ACCEPT_WITHOUT_BARCODE',
    NOT_SCANNED = 'NOT_SCANNED'
}

export interface IGoodsInfo extends IBaseEntity {
    id: number;
    goodsNo: string;
    goodsDescription: string;
    trackingNo: string;
    earlierTrackingNo?: string | null;
    groupNo: string;
    vin?: string | null;
    make?: string | null;
    model?: string | null;
    year?: string | null;
    startDate: string | null;
    deliveryDate: string | null;
    confirmedLoad: boolean;
    warehouseReturnType: WarehouseReturnType | null;
    warehouseReturnFirstCaptured: string | null;
    haulierOrderId: number | null;
    haulierOrderNo: number | null;
    runIds: string | null;
    loadNumber: string | null;
    docketNumber: string | null;
    customerName: string | null;
    collectionPoint: string | null;
    deliveryPoint: string | null;
    warehouseLoadingIssue: WarehouseLoadingIssue;
    createdOn: Date;
    packagingCollectReasonId: number;
    packagingDeliveryReasonId: number;
    packagingCollectReason: string | null;
    packagingDeliveryReason: string | null;
    scanType: ScanType;
    scanLocation: string | null;
    vehicle: string | null;
}

export class GoodsInfo extends BaseEntity implements IGoodsInfo {
    id: number;
    goodsNo: string;
    goodsDescription: string;
    trackingNo: string;
    earlierTrackingNo?: string | null;
    groupNo: string;
    vin?: string | null;
    make?: string | null;
    model?: string | null;
    year?: string | null;
    startDate: string | null;
    deliveryDate: string | null;
    confirmedLoad: boolean;
    warehouseReturnType: WarehouseReturnType | null;
    warehouseReturnFirstCaptured: string | null;
    haulierOrderId: number | null;
    haulierOrderNo: number | null;
    runIds: string | null;
    loadNumber: string | null;
    docketNumber: string | null;
    customerName: string | null;
    collectionPoint: string | null;
    deliveryPoint: string | null;
    warehouseLoadingIssue: WarehouseLoadingIssue;
    createdOn: Date;
    packagingCollectReasonId: number;
    packagingDeliveryReasonId: number;
    packagingCollectReason: string | null;
    packagingDeliveryReason: string | null;
    scanType: ScanType;
    scanLocation: string | null;
    vehicle: string | null;

    constructor(goodsInfo?) {
        super();
        if (goodsInfo) {
            this.id = goodsInfo.id;
            this.goodsNo = goodsInfo.goodsNo;
            this.goodsDescription = goodsInfo.goodsDescription;
            this.trackingNo = goodsInfo.trackingNo;
            this.earlierTrackingNo = goodsInfo.earlierTrackingNo;
            this.groupNo = goodsInfo.groupNo;
            this.vin = goodsInfo.vin;
            this.make = goodsInfo.make;
            this.model = goodsInfo.model;
            this.year = goodsInfo.year;
            this.startDate = goodsInfo.startDate;
            this.deliveryDate = goodsInfo.deliveryDate;
            this.confirmedLoad = goodsInfo.confirmedLoad;
            this.warehouseReturnType = goodsInfo.warehouseReturnType || WarehouseReturnType.NONE;
            this.warehouseReturnFirstCaptured = goodsInfo.warehouseReturnFirstCaptured;
            this.haulierOrderId = goodsInfo.haulierOrderId;
            this.haulierOrderNo = goodsInfo.haulierOrderNo;
            this.runIds = goodsInfo.runIds;
            this.loadNumber = goodsInfo.loadNumber;
            this.docketNumber = goodsInfo.docketNumber;
            this.customerName = goodsInfo.customerName;
            this.collectionPoint = goodsInfo.collectionPoint;
            this.deliveryPoint = goodsInfo.deliveryPoint;
            this.warehouseLoadingIssue = goodsInfo.warehouseLoadingIssue || WarehouseLoadingIssue.NONE;
            this.createdOn = goodsInfo.createdOn;
            this.packagingCollectReasonId = goodsInfo.packagingCollectReasonId;
            this.packagingDeliveryReasonId = goodsInfo.packagingDeliveryReasonId;
            this.packagingCollectReason = goodsInfo.packagingCollectReason;
            this.packagingDeliveryReason = goodsInfo.packagingDeliveryReason;
            this.scanType = goodsInfo.scanType || ScanType.NOT_SCANNED;
            this.scanLocation = goodsInfo.scanLocation;
            this.vehicle = goodsInfo.vehicle;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): GoodsInfo {
        return new GoodsInfo(this);
    }
}
